import comp from './LinkToUserProfile'
export default comp
